import React from 'react'
import DataGrid from '../../../../table/DataGrid';
import Editor from '../../../../FormControl/Editor';
import ChipMedia from '../../../../chip/ChipMedia';
import ReadOnlyTextEditor from '../../../../TextEditor/ReadOnlyTextEditor';

const FormWorkedExamplesPreview = ({ workedExamples = [] }) => {

  return (
    <div className='relative h-screen-half'>
      <DataGrid
        id='preview-worked-examples'
        showSetting={false}
        rows={workedExamples?.map((row, index) => {
          return {
            ...row,
            index: index + 1,
            workedExample: <div className='max-h-120px overflow-hidden relative'>
              <ReadOnlyTextEditor
                content={row.comment}
                readOnly={true}
              />
              { row.media && row.media.length > 0 &&
                <div className='flex flex-wrap gap-4 items-center absolute bottom-4'>
                  { row.media.map((data, index) => {
                      return (
                        <ChipMedia
                          key={`media-${index}-${data._id}-${data.type}`} 
                          index={index}
                          data={data} 
                        /> 
                      );
                    })
                  }
                </div>
              }
            </div>
          }
        })}
        rowsPerPage={workedExamples?.length || 0}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 20, show: true, hide: false },
          { label: 'Worked example', key: 'workedExample', show: true, hide: false },
        ]}
        labelNoRows="You don't have any worked examples yet"
      />
    </div>
  )
}

export default FormWorkedExamplesPreview